import { Component, Input, OnInit } from '@angular/core';
import { ElementStyleType } from '../../enums/element-style-type.enum';


@Component({
  selector: 'app-filter-by',
  templateUrl: './filter-by.component.html',
  styleUrls: ['./filter-by.component.scss']
})
export class FilterByComponent implements OnInit {
  @Input() styleType: ElementStyleType = ElementStyleType.Gray;

  constructor() { }

  ngOnInit(): void {
  }

}
